import '../initial-styles.css';

import { FC } from 'react';

type Props = {
  html: any;
}

const EditorContent:FC<Props> = ({
  // Props
  html
}) => {
  // console.log(styles);
  return (
    <div
      className="flex-grow text-sm p-4 initial-style"
      dangerouslySetInnerHTML={{
        __html: html
      }}
    />
  )
}

export default EditorContent;
